import { Box, Grid, Tab, Tabs, styled } from "@mui/material";

import React from "react";
import TradeWalletAction from "pages/BasicTrade/components/TradeWalletAction";
import { useSearchParams } from "react-router-dom";
import { useSelector } from "react-redux";

function TradeTypeTabs() {
  const tradeInitial = useSelector((state) => state.trade.tradeInitial?.data);

  const [searchParams, setSearchParams] = useSearchParams();
  const tradeTypeId = +searchParams.get("tradeTypeId") || 1;

  const handleChange = (_, newValue) => {
    const allSearchParams = Object.fromEntries([...searchParams]);
    setSearchParams({ ...allSearchParams, tradeTypeId: newValue });
  };

  return (
    <Wrapper container alignItems="flex-end" ml={1}>
      <Grid item xs={6}>
        <Tabs value={tradeTypeId} onChange={handleChange}>
          {tradeInitial?.lisTradeType?.map((wallet, index) => (
            <Tab label={wallet?.name} value={wallet?.id} key={index} />
          ))}
        </Tabs>
      </Grid>

      <Grid item xs={6}>
        <TradeWalletActionWrapper>
          <TradeWalletAction />
        </TradeWalletActionWrapper>
      </Grid>
    </Wrapper>
  );
}

const Wrapper = styled(Grid)(({ theme }) => ({
  borderBottom: `1px solid ${theme.palette.modules.border}`,
  marginBottom: theme.spacing(3),
}));

const TradeWalletActionWrapper = styled(Box)(({ theme }) => ({
  ".MuiBox-root": {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",

    ".MuiButtonBase-root": {
      marginLeft: theme.spacing(1),
      maxWidth: "90px",
    },
  },
}));

export default TradeTypeTabs;
